var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00012 16.1999L5.50012 12.6999C5.11012 12.3099 4.49012 12.3099 4.10012 12.6999C3.71012 13.0899 3.71012 13.7099 4.10012 14.0999L8.29012 18.2899C8.68012 18.6799 9.31012 18.6799 9.70012 18.2899L20.3001 7.69995C20.6901 7.30995 20.6901 6.68995 20.3001 6.29995C19.9101 5.90995 19.2901 5.90995 18.9001 6.29995L9.00012 16.1999Z",
    fill: "#1A1A1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMDAwMTIgMTYuMTk5OUw1LjUwMDEyIDEyLjY5OTlDNS4xMTAxMiAxMi4zMDk5IDQuNDkwMTIgMTIuMzA5OSA0LjEwMDEyIDEyLjY5OTlDMy43MTAxMiAxMy4wODk5IDMuNzEwMTIgMTMuNzA5OSA0LjEwMDEyIDE0LjA5OTlMOC4yOTAxMiAxOC4yODk5QzguNjgwMTIgMTguNjc5OSA5LjMxMDEyIDE4LjY3OTkgOS43MDAxMiAxOC4yODk5TDIwLjMwMDEgNy42OTk5NUMyMC42OTAxIDcuMzA5OTUgMjAuNjkwMSA2LjY4OTk1IDIwLjMwMDEgNi4yOTk5NUMxOS45MTAxIDUuOTA5OTUgMTkuMjkwMSA1LjkwOTk1IDE4LjkwMDEgNi4yOTk5NUw5LjAwMDEyIDE2LjE5OTlaIiBmaWxsPSIjMUExQTFBIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };